import { memo, useEffect, useState } from 'react';
import { useWindowDimensions } from 'react-native';
import { Box, Image } from '@bonanza-social/moonlight';
import { StatusRetentionAnimationProps } from './StatusRetentionAnimation.types';
import StatusHorizontalProgress from '../../StatusHorizontalProgress/StatusHorizontalProgress';
import StatusGemGlow from '../../StatusGemGlow/StatusGemGlow';

function StatusRetentionAnimation({
  onAnimationEnd,
  ...rest
}: StatusRetentionAnimationProps) {
  const { currentStatus, claimedBoxesCount = 0 } = rest;
  const { height: windowHeight } = useWindowDimensions();
  const [focusedBox, setFocusedBox] = useState(claimedBoxesCount + 1);
  const imageSize = windowHeight < 725 ? 140 : 208;
  const imageMargin = windowHeight < 725 ? 'space-300' : 'space-1000';

  useEffect(() => {
    if (focusedBox <= 1) {
      onAnimationEnd();

      return;
    }

    const timeoutId = setTimeout(() => {
      setFocusedBox(Math.max(1, focusedBox - 1));
    }, 300);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [focusedBox, onAnimationEnd]);

  if (currentStatus === 'Member') {
    return;
  }

  return (
    <Box flex={1} paddingHorizontal="space-600" centerContent>
      <Box marginVertical={imageMargin} alignItems="center" aspectRatio={1}>
        <Image
          name={`status.${currentStatus}Gem`}
          width={imageSize}
          height={imageSize}
        />
        <StatusGemGlow status={currentStatus} />
      </Box>
      <StatusHorizontalProgress
        {...rest}
        claimedBoxesCount={focusedBox}
        nextStatusRewardAmount={undefined}
      />
    </Box>
  );
}

export default memo(StatusRetentionAnimation);
